import React from "react";
import { Marker } from "react-map-gl/maplibre";

import { createComponent } from "@opendash/state";

import { $geo } from "..";
import { Autocomplete } from "./Autocomplete";
import { MapModal } from "./MapModal";
import { MapPolygonLayer } from "./MapPolygonLayer";
import { MarkerElement } from "./MarkerElement";

const ShowPolygonDialog = createComponent(function ShowPolygonDialog({}) {
  if (!$geo.dialogs.__showPolygonDialog) {
    return null;
  }

  return (
    <MapModal
      open={!!$geo.dialogs.__showPolygonDialog}
      initialLatitude={0}
      initialLongitude={0}
      onCancel={() => {
        $geo.dialogs.cancelShowPolygonDialog();
      }}
    >
      <MapPolygonLayer
        polygon={$geo.dialogs.__showPolygonDialog.polygon}
        centerOnChange
      />
    </MapModal>
  );
});

const ShowPointDialog = createComponent(function ShowPointDialog({}) {
  if (!$geo.dialogs.__showPointDialog) {
    return null;
  }

  const latitude = $geo.dialogs.__showPointDialog.latitude;
  const longitude = $geo.dialogs.__showPointDialog.longitude;

  return (
    <MapModal
      open={!!$geo.dialogs.__showPointDialog}
      initialLatitude={latitude}
      initialLongitude={longitude}
      onCancel={() => {
        $geo.dialogs.cancelShowPointDialog();
      }}
    >
      <Marker longitude={longitude} latitude={latitude}>
        <MarkerElement active />
      </Marker>
    </MapModal>
  );
});

const EditPointDialog = createComponent(function EditPointDialog({}) {
  if (!$geo.dialogs.__editPointDialog) {
    return null;
  }

  const latitude = $geo.dialogs.__editPointDialog.latitude;
  const longitude = $geo.dialogs.__editPointDialog.longitude;

  return (
    <MapModal
      open={!!$geo.dialogs.__editPointDialog}
      initialLatitude={latitude}
      initialLongitude={longitude}
      onSave={() => {
        $geo.dialogs.resolveEditPointDialog();
      }}
      onCancel={() => {
        $geo.dialogs.cancelEditPointDialog();
      }}
      onClick={(e) => {
        console.log(e.lngLat);
        $geo.dialogs.updateEditPointDialogPosition({
          latitude: e.lngLat.lat,
          longitude: e.lngLat.lng,
        });
      }}
    >
      <Autocomplete
        centerOnSelection
        onChange={(selection) => {
          $geo.dialogs.updateEditPointDialogPosition({
            latitude: selection.latitude,
            longitude: selection.longitude,
          });
        }}
      />
      <Marker longitude={longitude} latitude={latitude}>
        <MarkerElement active />
      </Marker>
    </MapModal>
  );
});

export const Globals = createComponent(function Globals({}) {
  return (
    <>
      <ShowPointDialog />
      <EditPointDialog />
      <ShowPolygonDialog />
    </>
  );
});
